import { type PartialPropsOf } from '@blaze-runtime/engine-domain';
import { applyPropsPatch } from '@blaze-runtime/engine-domain';

import { updateGeneratedTextInputContent } from '../../../canvas-elements/element-model/generated-field-props';
import { type FormFieldGenerationParams } from '../../__base/generation';

export function generateTextInputFormField(
  params: FormFieldGenerationParams<'textInput'>,
): PartialPropsOf<'textInput'> {
  let props: PartialPropsOf<'textInput'> = updateGeneratedTextInputContent(
    params.inputData,
    params.props,
  );

  props = applyPropsPatch(props, {
    style: {
      general: { offset: { margin: '$t.spacingFormField' } },
    },
  });

  if (params.inputData.readonly) {
    props = applyPropsPatch(props, {
      content: { input: { readonly: true } },
      style: {
        input: {
          border: { selectorType: 'none' },
          fill: { color1: 'transparent' },
        },
      },
    });
  }

  return props;
}
